var _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 161,
    viewBox: "0 0 160 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M134.312 77.9845C148.499 63.7977 148.499 40.7963 134.312 26.6094C120.126 12.4226 97.1242 12.4226 82.9374 26.6094L25.6876 83.8592C11.5007 98.0461 11.5007 121.047 25.6876 135.234C39.8744 149.421 62.8758 149.421 77.0627 135.234L134.312 77.9845Z",
    fill: "#0076FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M114.698 48.0527C114.698 48.0527 114.698 49.6004 114.698 53.5626C114.698 57.5247 111.8 62.6259 102.539 69.4234C93.2775 76.2209 90.3802 77.9172 90.3802 80.7526C90.3802 83.588 97.3263 88.5406 102.539 93.0104C107.752 97.4802 114.698 102.854 114.698 107.955V113.465C116.53 113.465 118.808 115.755 118.808 118.566C118.808 121.364 116.468 123.667 113.596 123.667H56.5907C55.0059 123.667 53.5696 122.962 52.6162 121.847",
    stroke: "#0076FF",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M127.884 68.8793C130.072 68.8793 131.846 67.1054 131.846 64.9172C131.846 62.729 130.072 60.9551 127.884 60.9551C125.696 60.9551 123.922 62.729 123.922 64.9172C123.922 67.1054 125.696 68.8793 127.884 68.8793Z",
    stroke: "#0076FF",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.6686 94.2865C38.8569 94.2865 40.6308 92.5126 40.6308 90.3244C40.6308 88.1362 38.8569 86.3623 36.6686 86.3623C34.4804 86.3623 32.7065 88.1362 32.7065 90.3244C32.7065 92.5126 34.4804 94.2865 36.6686 94.2865Z",
    fill: "#0076FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M133.827 125.624C134.921 125.624 135.808 124.737 135.808 123.643C135.808 122.549 134.921 121.662 133.827 121.662C132.733 121.662 131.846 122.549 131.846 123.643C131.846 124.737 132.733 125.624 133.827 125.624Z",
    fill: "#0076FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.079 27.0537V32.093",
    stroke: "#0076FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.813 41.3799H123.773",
    stroke: "#0076FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.43 31.4248L120.728 35.1393",
    stroke: "#0076FF",
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6687 29.5303V38.2841",
    stroke: "#0076FF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2856 33.9014H41.0394",
    stroke: "#0076FF",
    strokeMiterlimit: 10
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6162 53.7119C52.6162 57.7607 55.5135 62.9734 64.775 69.9195C74.0364 76.8656 76.9337 78.599 76.9337 81.4963C76.9337 84.3936 69.9876 89.4577 64.775 94.0141C59.5623 98.5705 52.6162 104.068 52.6162 109.281V114.902",
    stroke: "#3A99F9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.875 48.0781C111.875 48.0781 111.875 49.6506 111.875 53.6994C111.875 57.7482 108.977 62.9608 99.7159 69.9069C90.4545 76.853 87.5572 78.5865 87.5572 81.4838C87.5572 84.3811 94.5033 89.4451 99.7159 94.0016C104.929 98.558 111.875 104.055 111.875 109.268",
    stroke: "#3A99F9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.395 40.8721H52.1705C50.1806 40.8721 48.5674 42.4852 48.5674 44.4751C48.5674 46.465 50.1806 48.0782 52.1705 48.0782H112.395C114.385 48.0782 115.998 46.465 115.998 44.4751C115.998 42.4852 114.385 40.8721 112.395 40.8721Z",
    stroke: "#3A99F9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.395 114.89H52.1705C50.1806 114.89 48.5674 116.503 48.5674 118.493C48.5674 120.483 50.1806 122.096 52.1705 122.096H112.395C114.385 122.096 115.998 120.483 115.998 118.493C115.998 116.503 114.385 114.89 112.395 114.89Z",
    stroke: "#3A99F9",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4523 110.877C68.4523 103.176 80.0291 97.9014 82.2702 97.9014C84.5113 97.9014 96.0881 103.176 96.0881 110.877H68.4399H68.4523Z",
    fill: "#07DD80"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.126 68.8789C75.126 72.6058 81.1187 76.1841 82.2826 76.1841C83.4464 76.1841 89.4391 72.6058 89.4391 68.8789H75.126Z",
    fill: "#07DD80"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2702 80.876V83.3028",
    stroke: "#07DD80",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2702 87.8965V92.7377",
    stroke: "#07DD80",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.b0549be73ea7e907b680bfc21155aa69.svg";
export { ForwardRef as ReactComponent };